// src/app/core/pwa/interfaces/pwa.interface.ts

export interface PwaPreferences {
  dismissed: boolean;
  dismissedAt: Date | null;
  showCount: number;
  lastShown: Date | null;
  installed: boolean;
}

export interface PwaPromptEvent {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export interface PwaInstallState {
  canInstall: boolean;
  isInstalled: boolean;
  isStandalone: boolean;
  promptEvent: PwaPromptEvent | null;
}

export enum PwaPromptStatus {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
  INSTALLING = 'installing',
  DISMISSED = 'dismissed'
}
